export default __webpack_public_path__ + "static/media/ajman-department-of-economic-development.2f0895d3.png";